<div class="card">
    <div class="grid">
        <div class="col-6">
            <p-table stripedRows #ContractTable
                styleClass="table"
                [value]="contracts"
                [style]="{ 'min-width': '15em' }"
                scrollHeight="65em"
                editMode="row"
                dataKey="ContractListID"
                [scrollable]="true"
            >
                <!-- <ng-template pTemplate="caption">
                    <label
                        style="
                            background-color: #efefef;
                            color: #efefef;
                            padding: 1em;
                            margin: 0.35em;
                        "
                    ></label>
                </ng-template> -->
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="17" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #header>
                    <tr>
                        <th pSortableColumn="ContractDesc">
                            Contract
                                <p-sortIcon
                                    field="ContractDesc"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                >
                                </p-sortIcon>
                                <p-columnFilter field="ContractListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect
                                            defaultLabel="Filter"
                                            maxSelectedLabels="1"
                                            appendTo="body"
                                            [options]="contractsSelectItem"
                                            [filter]="true"
                                            styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)"
                                        ></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                        </th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template #body let-contract let-ri="rowIndex">
                    <tr data-id="row-{{ contract.ContractListID }}">
                        <td>
                            {{ contract.ContractDesc }}
                        </td>
                        <td>
                            <button
                                pButton
                                pRipple
                                class="p-button-text"
                                label="Classes"
                                (click)="
                                    classesClicked(
                                        contract.ContractListID,
                                        contract.ContractDesc
                                    )
                                "
                            ></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="col-6">
            <p-table stripedRows #ClassesTable
                [value]="contractClasses"
                [style]="{ 'min-width': '15em' }"
                scrollHeight="65em"
                dataKey="ClassListID"
                selectionMode="multiple"
                [(selection)]="selected"
                (onRowSelect)="onRowSelect($event)"
                [scrollable]="true"
            >
                <ng-template pTemplate="caption">
                    <div class="flex items-center">
                        <button
                            pRipple
                            pButton
                            severity="primary"
                            class="mr-2"
                            label="Assign All"
                            style="font-size: 14px"
                            (click)="assignAllClicked()"
                        ></button>
                        <button
                            pRipple
                            pButton
                            severity="primary"
                            label="Unassign All"
                            style="font-size: 14px"
                            (click)="unassignAllClicked()"
                        ></button>
                    </div>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="17" style="text-align: center">
                            <div class="tabulator-placeholder">
                                <span> No Data Available </span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template #header>
                    <tr>
                        <th class="status-cell">
                            <i
                                class="pi pi-exclamation-circle"
                                title="Status"
                            ></i>
                        </th>
                        <th class="w-1">
                            Assign
                        </th>
                        <th pSortableColumn="ClassName">
                            Class *{{ this.selectedContract }}*
                                <p-sortIcon
                                    field="ClassName"
                                    ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"
                                >
                                </p-sortIcon>
                                <p-columnFilter field="ClassListID" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect
                                            defaultLabel="Filter"
                                            maxSelectedLabels="1"
                                            appendTo="body"
                                            [options]="classesSelectItem"
                                            [filter]="true"
                                            styleClass="w-full"
                                            [ngModel]="value"
                                            (ngModelChange)="filter($event)"
                                        ></p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                        </th>
                    </tr>
                </ng-template>
                <ng-template #body let-class let-ri="rowIndex">
                    <tr>
                        <td class="status-cell">
                            <a
                                (click)="
                                    ShowError.next({
                                        open: !!class.ClassListID,
                                        MsgEntityID: class.ClassListID
                                    })
                                "
                            >
                                <div>
                                    <ef-status-icon
                                        [status]="class?.Status?.StatusCode"
                                        [message]="class?.Status?.Message"
                                    ></ef-status-icon>
                                </div>
                            </a>
                        </td>
                        <td class="w-1">
                            <p-checkbox
                                [(ngModel)]="class.IsContractClass"
                                binary="true"
                                inputId="binary"
                                (onChange)="
                                    IsContractClassChecked($event, class)
                                "
                            ></p-checkbox>
                        </td>
                        <td>
                            {{ class.ClassName }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
